import client, { throwCaughtError } from "../client";
import type { ScimConnectionSummary } from "@/lib/scim";

export const scimConnectionsOptions = (companyId: string) => ({
  queryKey: ["scimConnections", companyId],
  queryFn: () => getScimConnections(companyId),
  enabled: !!companyId,
});

export const getScimConnections = async (
  companyId: string,
): Promise<ScimConnectionSummary[]> => {
  try {
    const response = await client.get(
      `/getScimConnections?companyId=${encodeURIComponent(companyId)}`,
    );
    return response.data.connections;
  } catch (error) {
    // Keeps .status so the query retry policy can tell 4xx from 5xx.
    throwCaughtError(error);
    throw error;
  }
};

/** Returns the plaintext token; it is never retrievable again. */
export const createScimConnection = async (
  companyId: string,
  name: string,
  expiresAt: string | null,
): Promise<{ connection: ScimConnectionSummary; token: string }> => {
  const response = await client.post("/createScimConnection", {
    companyId,
    name,
    expiresAt,
  });
  return response.data;
};

export const rotateScimConnection = async (
  companyId: string,
  connectionId: string,
): Promise<{ token: string }> => {
  const response = await client.post("/rotateScimConnection", {
    companyId,
    connectionId,
  });
  return response.data;
};

export const revokeScimConnection = async (
  companyId: string,
  connectionId: string,
): Promise<{ detachedUsers: number }> => {
  const response = await client.post("/revokeScimConnection", {
    companyId,
    connectionId,
  });
  return response.data;
};
